module.exports = __webpack_public_path__ + "static/media/smares-smart-menu.49b7d81d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posts/smares-smart-menu.jpg
// module id = 407
// module chunks = 0